import { IPrepaidroomcluster } from '@core/models/PrepaidRoomCluster/IPrepaidRoomCluster';
import { IHotelAvailability } from '@core/models/HotelAvailability/IHotelAvailability';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './hotelAvailability.actions';
import { RoomFilter } from '@core/models/room-filter/room-filter';
import { PrepaidRoomCluster } from '@core/models/PrepaidRoomCluster/PrepaidRoomCluster.model';
import { DisneyRoomCluster } from '@core/models/disney-room-cluster/DisneyRoomCluster.model';
import { cloneDeep } from 'lodash';

export interface IStateHotelAvailability {
  hotelAvailability: IHotelAvailability;
  roomDetails: {
    [key: string]: any;
  };
  allRefundableRoomCluster: IPrepaidroomcluster[];
  filters: RoomFilter[];
  roomsFiltered: any[];
  allRooms: any[];
  disneyRooms: DisneyRoomCluster[];
  disneyLegacyRooms: Map<string, any>;
  pageSize: number;
  initialPageSize: number;
  loading: boolean;
}

const initialState: IStateHotelAvailability = {
  hotelAvailability: null,
  allRefundableRoomCluster: null,
  filters: [],
  roomsFiltered: [],
  allRooms: [],
  disneyRooms: [],
  loading: true,
  initialPageSize: 100,
  pageSize: 100,
  roomDetails: {},
  disneyLegacyRooms: new Map(),
} as IStateHotelAvailability;

const _availabilityReducer = createReducer(
  initialState,
  on(actions.setHotelAvailability, (state, { hotelAvailability }) => {
    const availabilityClone = cloneDeep(hotelAvailability);
    let allRooms = [];
    // This is to order 2 PREPAID, 2 PAID_AT_DESTINATION rooms
    while (
      hotelAvailability.prepaid_room_clusters.length > 0 ||
      hotelAvailability.paid_at_destination_room_clusters.length > 0
    ) {
      allRooms = allRooms.concat([
        hotelAvailability.prepaid_room_clusters.shift(),
        hotelAvailability.prepaid_room_clusters.shift(),
        hotelAvailability.paid_at_destination_room_clusters.shift(),
        hotelAvailability.paid_at_destination_room_clusters.shift(),
      ]);
    }
    allRooms = allRooms
      .filter((room) => room)
      .map((room) => new PrepaidRoomCluster(room));
    const roomDetails: {
      [key: string]: any;
    } = {};
    if (hotelAvailability.rooms_detail) {
      (hotelAvailability.rooms_detail as unknown as any[]).forEach((detail) => {
        roomDetails[detail.id] = detail;
      });
    }
    return {
      ...state,
      hotelAvailability: availabilityClone,
      roomsFiltered: allRooms,
      loading: false,
      roomDetails,
      allRooms,
    };
  }),
  on(actions.setAllRefundableRoomCluster, (state, { allRefundableRoomCluster }) => {
    return {
      ...state,
      allRefundableRoomCluster: allRefundableRoomCluster,
    };
  }),
  on(actions.setDisneyCluster, (state, { clusters }) => {
    return {
      ...state,
      roomsFiltered: clusters,
      allRooms: clusters,
    };
  }),
  on(actions.setDisneyClusterLegacy, (state, { clusters }) => {
    // ToDo: Delete after migrating detail to desktop
    const clustersMap: Map<string, any> = new Map();
    clusters.forEach((cluster) =>
      clustersMap.set(cluster.rooms[0].room_description.description, cluster),
    );
    return {
      ...state,
      disneyLegacyRooms: clustersMap,
    };
  }),
  on(actions.setRoomsFilters, (state, { filters }) => {
    return {
      ...state,
      filters,
    };
  }),
  on(actions.setEmptyRoomsFilters, state => {
    return {
      ...state,
      filters: [],
    };
  }),
  on(actions.changeRoomFilter, (state, { filter }) => {
    let { filters } = state;

    filters = filters.filter((f) => f.filter !== filter.filter);

    return {
      ...state,
      loading: true,
      filters: filters.concat(filter),
    };
  }),
  on(actions.setFilteredRooms, (state, { rooms }) => {
    return {
      ...state,
      loading: false,
      roomsFiltered: rooms,
    };
  }),
  on(actions.showMoreRooms, (state) => {
    return {
      ...state,
      pageSize: state.pageSize + state.initialPageSize,
    };
  }),
  on(actions.resetFilters, (state) => {
    const { filters } = state;
    filters.forEach((f) => {
      f.active = false;
    });
    return {
      ...state,
      roomsFiltered: [].concat(state.allRooms),
      filters: [].concat(filters),
      pageSize: state.initialPageSize,
    };
  }),
  on(actions.unsetFilters, (state) => {
    return {
      ...state,
      filters: [],
    };
  }),
  on(actions.setPageSize, (state, { pageSize }) => {
    return {
      ...state,
      initialPageSize: pageSize,
      pageSize,
    };
  }),
  on(actions.resetPagination, (state) => {
    return {
      ...state,
      pageSize: state.initialPageSize,
    };
  }),
  on(actions.resetHotelAvailability, (state) => {
    return {
      ...state,
      hotelAvailability: null,
    };
  }),
);

export function availabilityReducer(state: IStateHotelAvailability, action: Action) {
  return _availabilityReducer(state, action);
}
